export default __webpack_public_path__ + "static/media/Mercadopago.a6ae3e8b.svg";